export default {
  title: 'Neue Charge konfigurieren',
  submitLabel: '{recipeCode} laden',
};
